import  request  from '../../Interceptor/request.js'

//关于我们
export function aboutUs() {
    return request({
        url: '/member/aboutOur',
        method: 'get'
    })
}

